export default function CustomerImportUploadCard({ fileName, onFileChange }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-4 shadow-sm">
      <h3 className="text-base font-semibold text-slate-900">1. Bestand uploaden</h3>
      <p className="mt-1 text-sm text-slate-500">Ondersteund: CSV en XLSX.</p>

      <div className="mt-3 flex flex-wrap items-center gap-3">
        <input
          type="file"
          accept=".csv,text/csv,.xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          onChange={onFileChange}
          className="rounded-lg border border-slate-200 px-3 py-2 text-sm"
        />
        {fileName && <span className="text-sm text-slate-600">Bestand: {fileName}</span>}
      </div>
    </div>
  );
}
